"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var dot_loader_module_scss_1 = __importDefault(require("./dot-loader.module.scss"));

var DotLoader = function DotLoader() {
  return react_1.default.createElement("span", {
    className: dot_loader_module_scss_1.default.wrapper
  }, react_1.default.createElement("i", null, "."), react_1.default.createElement("i", null, "."), react_1.default.createElement("i", null, "."));
};

exports.default = DotLoader;